import React from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/lib/Async';
import 'whatwg-fetch';
import DatePicker from 'react-bootstrap-date-picker';
import moment from 'moment';

import data_operators from 'src/data/dashlet/operators';
import data_criticity from 'src/data/criticity';
import data_priority from 'src/data/priority';
import data_ticket_state from 'src/data/ticket-state';
import data_task_state from 'src/data/planning-state';
import data_deal_step from 'src/data/deal-step';
import withAuth from 'src/hoc/withAuth';

class AppFilterInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnSelected: undefined,
      operators: undefined,
      operatorSelected: undefined,
      nbParam: 0,
      param1: undefined,
      param2: undefined,
      picklist: undefined,
      picklistSelected: undefined,
      search: ' ',
      dataFiles: {
        data_criticity: data_criticity,
        data_priority: data_priority,
        data_ticket_state: data_ticket_state,
        data_task_state: data_task_state,
        data_deal_step: data_deal_step,
      },
    };
    this.handleInputSelectChange = this.handleInputSelectChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleDateChange2 = this.handleDateChange2.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.refreshResult = this.refreshResult.bind(this);
  }

  handleInputSelectChange(val, typeSelect) {
    this.setState({
      [typeSelect]: val,
    });

    switch (typeSelect) {
      case 'columnSelected':
        if (!val) {
          this.props.removeFilter && this.props.removeFilter(this.props.id);
        } else {
          this.props.updateListFilters(
            this.props.id,
            val,
            this.state.operatorSelected,
            this.state.param1,
            this.state.param2
          );
        }
        break;
      case 'operatorSelected':
        this.props.updateListFilters(
          this.props.id,
          this.state.columnSelected,
          val,
          this.state.param1,
          this.state.param2
        );
        break;
      case 'param1':
        this.props.updateListFilters(
          this.props.id,
          this.state.columnSelected,
          this.state.operatorSelected,
          val,
          this.state.param2
        );
        break;
      case 'param2':
        this.props.updateListFilters(
          this.props.id,
          this.state.columnSelected,
          this.state.operatorSelected,
          this.state.param1,
          val
        );
        break;
      case 'picklistSelected':
        this.props.updateListFilters(
          this.props.id,
          this.state.columnSelected,
          this.state.operatorSelected,
          val,
          this.state.param2
        );
        break;
    }
  }

  handleDateChange(value, formattedValue) {
    this.setState({
      //value: value, // ISO String, ex: "2016-11-19T12:00:00.000Z"
      param1: formattedValue, // Formatted String, ex: "11/19/2016"
    });

    this.props.updateListFilters(
      this.props.id,
      this.state.columnSelected,
      this.state.operatorSelected,
      formattedValue,
      this.state.param2
    );
  }

  handleDateChange2(value, formattedValue) {
    this.setState({
      //value: value, // ISO String, ex: "2016-11-19T12:00:00.000Z"
      param2: formattedValue, // Formatted String, ex: "11/19/2016"
    });
    this.props.updateListFilters(
      this.props.id,
      this.state.columnSelected,
      this.state.operatorSelected,
      this.state.param1,
      formattedValue
    );
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    this.props.updateListFilters(
      this.props.id,
      this.state.columnSelected,
      this.state.operatorSelected,
      value,
      this.state.param2
    );
  }

  refreshResult(input) {
    let queryURL = this.state.columnSelected.apiRequest;
    let graphQL = '{ customers(search:"' + input + '"){ id, installationSite{ socialReason } } }';
    queryURL += graphQL;

    return this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          let dataToMap = data['data'][this.state.columnSelected.dataReturn];

          let test = this.state.columnSelected.picklistComposition;
          let mapped = dataToMap.map((p) => {
            return {
              ...p,
              value: p[test[0]][test[1]],
              label: p[test[0]][test[1]],
            };
          });

          return { options: mapped, complete: true };
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch search async: \n' + error);
          return { options: [], complete: true };
        }.bind(this)
      );
  }

  componentDidMount() {
    if (this.props.save) {
      //Initiliaze the component with the values saved by the parent
      let savedObject = this.props.save;
      let nbParam = 0;
      if (savedObject.param1 && savedObject.param2) {
        nbParam = 2;
      } else if (savedObject.param1 && !savedObject.param2) {
        nbParam = 1;
      }
      this.setState({
        columnSelected: savedObject.columnSelected,
        operatorSelected: savedObject.operatorSelected,
        nbParam: nbParam,
        param1: savedObject.param1,
        param2: savedObject.param2,
        picklistSelected: savedObject.param1,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.columnSelected !== this.state.columnSelected && this.state.columnSelected) {
      if (prevState.columnSelected !== undefined) {
        this.setState({
          param1: undefined,
          param2: undefined,
          picklistSelected: undefined,
          operatorSelected: undefined,
        });
      }

      data_operators.map((data) => {
        if (data.type === this.state.columnSelected.type) {
          this.setState({
            operators: data.choices,
          });
        }
      });

      // Fetch GET
      if (this.state.columnSelected.apiRequest && this.state.columnSelected.graphQlRequest) {
        this.requestToFillPicklist();
      } else if (this.state.columnSelected.dataFile) {
        let arrayPickList = [];
        let keys = Object.keys(this.state.dataFiles[this.state.columnSelected.dataFile]);
        for (let i = 0; i < keys.length; i++) {
          arrayPickList.push(this.state.dataFiles[this.state.columnSelected.dataFile][keys[i]]);
        }
        this.setState({
          picklist: arrayPickList,
        });
      }
    }

    return true;
  }

  /*
        If a fetch request is needed to fill the picklist we use this method. It's used for example for employees or origins
    */
  requestToFillPicklist() {
    let queryURL = this.state.columnSelected.apiRequest;
    let graphQL = this.state.columnSelected.graphQlRequest;
    queryURL += graphQL;

    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          this.setState({
            picklist: data['data'][this.state.columnSelected.dataReturn],
          });
        }.bind(this)
      )
      .catch(
        function () {
          console.log('erreur fetch');
        }.bind(this)
      );
  }

  render() {
    return (
      <div className='rowFilter marked-positive'>
        <Select
          multi={false}
          className='inputModalSelect'
          name='columnSelected'
          value={this.state.columnSelected}
          labelKey={'label'}
          valueKey={'label'}
          options={this.props.columnsOfModule}
          onChange={(val) => this.handleInputSelectChange(val, 'columnSelected')}
          noResultsText={'Aucun résultat'}
          clearValueText={'Supprimer'}
        />
        {this.state.columnSelected && this.state.operators && (
          <Select
            multi={false}
            className='inputModalSelect'
            name='operatorSelected'
            value={this.state.operatorSelected}
            labelKey={'label'}
            valueKey={'label'}
            options={this.state.operators}
            onChange={(val) => this.handleInputSelectChange(val, 'operatorSelected')}
            noResultsText={'Aucun résultat'}
            clearValueText={'Supprimer'}
          />
        )}
        {this.state.operatorSelected &&
          this.state.operatorSelected.nbParam >= 1 &&
          this.state.columnSelected &&
          this.state.columnSelected.type === 'date' &&
          (this.state.param1 === undefined ||
            (this.state.param1 !== undefined && moment(this.state.param1).isValid())) && (
            <div className='form-group'>
              <label>Début</label>
              <DatePicker
                calendarContainer={this}
                name='param1'
                value={this.state.param1}
                onChange={this.handleDateChange}
                dateFormat='YYYY-MM-DD'
              />
            </div>
          )}
        {this.state.operatorSelected &&
          this.state.operatorSelected.nbParam >= 2 &&
          this.state.columnSelected &&
          this.state.columnSelected.type === 'date' &&
          (this.state.param2 === undefined ||
            (this.state.param2 !== undefined && moment(this.state.param1).isValid())) && (
            <div className='form-group'>
              <label>Fin</label>
              <DatePicker
                calendarContainer={this}
                name='param2'
                value={this.state.param2}
                onChange={this.handleDateChange2}
                dateFormat='YYYY-MM-DD'
              />
            </div>
          )}
        {this.state.operatorSelected &&
          this.state.operatorSelected.nbParam >= 1 &&
          this.state.columnSelected &&
          this.state.columnSelected.type === 'picklist' &&
          !this.state.columnSelected.isSophisticated && (
            <div className='form-group'>
              <Select
                multi={this.state.columnSelected.multi}
                className='inputModalSelect'
                name='picklistSelected'
                value={this.state.picklistSelected}
                labelKey={this.state.columnSelected.picklistLabel}
                valueKey={this.state.columnSelected.picklistLabel}
                options={this.state.picklist}
                onChange={(val) => this.handleInputSelectChange(val, 'picklistSelected')}
                noResultsText={'Aucun résultat'}
                clearValueText={'Supprimer'}
              />
            </div>
          )}
        {this.state.operatorSelected &&
          this.state.operatorSelected.nbParam >= 1 &&
          this.state.columnSelected &&
          this.state.columnSelected.type === 'picklist' &&
          this.state.columnSelected.isSophisticated && (
            <AsyncSelect
              name='picklistSelected'
              onChange={(val) => this.handleInputSelectChange(val, 'picklistSelected')}
              value={this.state.picklistSelected}
              multi={this.state.columnSelected.multi}
              cacheOptions={false}
              defaultOptions
              autoload={false}
              loadOptions={this.refreshResult}
            />
          )}

        {/* Number possibilities */}
        {this.state.operatorSelected &&
          this.state.operatorSelected.nbParam >= 1 &&
          this.state.columnSelected &&
          this.state.columnSelected.type === 'numeric' && (
            <div className='form-group'>
              <input
                min='0'
                name='param1'
                value={this.state.param1}
                onChange={this.handleInputChange}
                type='number'
                className='form-control'
              />
            </div>
          )}
        {this.state.operatorSelected &&
          this.state.operatorSelected.nbParam >= 2 &&
          this.state.columnSelected &&
          this.state.columnSelected.type === 'numeric' && (
            <div className='form-group'>
              <input
                min='0'
                name='param2'
                value={this.state.param2}
                onChange={this.handleInputChange}
                type='number'
                className='form-control'
              />
            </div>
          )}

        {/* Text possibilities */}
        {this.state.operatorSelected &&
          this.state.operatorSelected.nbParam >= 1 &&
          this.state.columnSelected &&
          this.state.columnSelected.type === 'text' && (
            <div className='form-group'>
              <input
                name='param1'
                value={this.state.param1}
                onChange={this.handleInputChange}
                type='text'
                className='form-control'
              />
            </div>
          )}
      </div>
    );
  }
}

export default withAuth(AppFilterInput);
